import _ from 'lodash';
// initial state
const initialState = {
  accessToken: {},
  info: {},
  timeData: {},
};

// getters
const getters = {
  getPermissions(state) {
    if (!state.info || !state.info.roles) return [];
    const permissionsArrs = state.info.roles.map(role => role.permissions);
    let permissions = [];
    for (let i = 0; i < permissionsArrs.length; i += 1) {
      permissions = permissions.concat(permissionsArrs[i]);
    }
    return _.uniqBy(permissions, 'id');
  },
  getPermissionsObject(state) {
    if (!state.info || !state.info.roles) return [];
    const permissionsArrs = state.info.roles.map(role => role.permissions);
    let permissions = [];
    for (let i = 0; i < permissionsArrs.length; i += 1) {
      permissions = permissions.concat(permissionsArrs[i]);
    }
    const arr = _.uniqBy(permissions, 'id');
    const result = {};
    for (let i = 0; i < arr.length; i += 1) {
      result[arr[i].id] = arr[i];
    }
    return result;
  },
  getId(state) {
    return state.info.id;
  },
  getGoogle2faInfo(state) {
    return state.info.google2fa_enabled;
  },
};

// actions
const actions = {

};

// mutations
const mutations = {
  storeAccessToken(state, playload) {
    state.accessToken = playload;
  },
  setInfo(state, playload) {
    state.info = playload;
  },
  setTimeData(state, playload) {
    state.timeData = playload;
  },
  setGoogle2faInfo(state, playload) {
    state.info.google2fa_enabled = playload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js